import { render, staticRenderFns } from "./updatepassword.vue?vue&type=template&id=6865af8d&scoped=true&"
import script from "./updatepassword.vue?vue&type=script&lang=js&"
export * from "./updatepassword.vue?vue&type=script&lang=js&"
import style0 from "./updatepassword.vue?vue&type=style&index=0&id=6865af8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6865af8d",
  null
  
)

export default component.exports